import React from 'react';
import { Wrench } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-4 pb-8 md:pt-8 md:pb-12 overflow-hidden" aria-label="Presentación del MegaPack Herrería Blindada" style={{
    contain: 'layout'
  }} data-id="element-113">
      <div className="container mx-auto px-4 relative z-10" data-id="element-114">
        <div className="flex flex-col items-center" data-id="element-115">
          <div className="flex-1 text-center max-w-4xl" data-id="element-116">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 mb-4 rounded-full border border-gold/40 bg-gold/10" data-id="element-117">
              <Wrench className="w-3.5 h-3.5 text-gold" aria-hidden="true" data-id="element-118" />
              <span className="text-gold text-xs font-semibold uppercase tracking-wider" data-id="element-119">
                MegaPack Herrería Blindada
              </span>
            </div>
            <h1 className="md:text-7xl font-bold mb-4 text-[#FFFFFF] text-[26px]" data-id="element-120">
              Todo tu taller de herrería listo. Desde hoy.
            </h1>

            <div className="mb-8 relative" data-id="element-121">
              <div className="absolute inset-0 z-0 pointer-events-none" aria-hidden="true" style={{
              background: 'radial-gradient(circle at center, rgba(234,122,46,0.22) 0%, rgba(234,122,46,0) 60%)'
            }} data-id="element-122"></div>
              <img src="https://cdn.magicpatterns.com/uploads/84g57gk8zvCpqt2fzfEcbE/DIGITAL-EBOOK-DISENOS-TECNICAS-AVANZADAS-_1_.webp?w=720&q=80" srcSet="https://cdn.magicpatterns.com/uploads/84g57gk8zvCpqt2fzfEcbE/DIGITAL-EBOOK-DISENOS-TECNICAS-AVANZADAS-_1_.webp?w=480&q=80 480w, https://cdn.magicpatterns.com/uploads/84g57gk8zvCpqt2fzfEcbE/DIGITAL-EBOOK-DISENOS-TECNICAS-AVANZADAS-_1_.webp?w=720&q=80 720w, https://cdn.magicpatterns.com/uploads/84g57gk8zvCpqt2fzfEcbE/DIGITAL-EBOOK-DISENOS-TECNICAS-AVANZADAS-_1_.webp?w=1120&q=80 1120w" alt="MegaPack Herrería Blindada — El sistema N°1 para herreros" className="mx-auto block w-[360px] md:w-[560px] h-auto relative z-10" width={560} height={560} sizes="(min-width: 768px) 560px, 360px"
            // @ts-ignore
            fetchpriority="high" decoding="async" loading="eager" data-id="element-123" />
            </div>

            <p className="text-lg mb-8 max-w-2xl mx-auto text-[#FFFFFF]" data-id="element-124">
              Costos, presupuestos, planos, mano de obra y anti-inflación
              listos. Sin improvisar ni perder plata.
            </p>

            <button onClick={() => {
            const target = document.getElementById('cta-comprar');
            if (target) {
              target.scrollIntoView({
                behavior: 'smooth',
                block: 'end'
              });
            }
          }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-5 text-lg font-bold text-background bg-gold rounded-xl hover:bg-gold/90 transition-colors uppercase tracking-wider cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold shadow-[0_0_20px_rgba(234,122,46,0.35)] hover:shadow-[0_0_30px_rgba(234,122,46,0.5)]" data-id="element-125">
              🔩 → QUIERO MI MEGAPACK AHORA
            </button>

            <div className="flex flex-wrap justify-center gap-4 mt-8 mb-6" role="list" aria-label="Características principales" data-id="element-126">
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-127">
                <span className="text-2xl" aria-hidden="true" data-id="element-128">
                  📄
                </span>
                <span className="font-medium text-sm" data-id="element-129">100% PDF</span>
              </div>
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-130">
                <span className="text-2xl" aria-hidden="true" data-id="element-131">
                  ⚡
                </span>
                <span className="font-medium text-sm" data-id="element-132">Acceso en 5 min</span>
              </div>
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-133">
                <span className="text-2xl" aria-hidden="true" data-id="element-134">
                  🇦🇷
                </span>
                <span className="font-medium text-sm" data-id="element-135">Hecho en Argentina</span>
              </div>
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-136">
                <span className="text-2xl" aria-hidden="true" data-id="element-137">
                  🔧
                </span>
                <span className="font-medium text-sm" data-id="element-138">Todas las obras</span>
              </div>
            </div>

            <div className="flex flex-wrap justify-center items-center gap-6 mt-6 text-sm text-gray-400" data-id="element-139">
              <div className="flex items-center gap-2" data-id="element-140">
                <span className="text-gold" aria-hidden="true" data-id="element-141">
                  🛡️
                </span>
                <span data-id="element-142">Garantía 7 días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-143">
                <span className="text-gold" aria-hidden="true" data-id="element-144">
                  🔒
                </span>
                <span data-id="element-145">Pago seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-146">
                <span className="text-gold" aria-hidden="true" data-id="element-147">
                  💳
                </span>
                <span data-id="element-148">Mercado Pago</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}